import React, { useState, useEffect } from "react";

export default function ProductVisual({
  desktopPageImageUrl,
  mobilePageImageUrl,
}) {
  const [imageUrlToDisplay, setImageUrlToDisplay] = useState(desktopPageImageUrl);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setImageUrlToDisplay(mobilePageImageUrl);
      } else {
        setImageUrlToDisplay(desktopPageImageUrl);
      }
    };

    handleResize(); // Set initial image based on current screen width
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [desktopPageImageUrl, mobilePageImageUrl]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundImage: `url(${imageUrlToDisplay})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* This div is now just a full-screen background. Content (popup) will be overlaid by ProductPage.jsx */}
    </div>
  );
}
